module.exports = __webpack_public_path__ + "img/5.a098034d.png";